import { Toaster } from "react-hot-toast";
import { useTheme } from "styled-components/macro";

const ToasterDefault = () => {
  const theme = useTheme();

  return (
    <Toaster
      position="bottom-center"
      reverseOrder={false}
      toastOptions={{
        duration: 5000,
        style: {
          borderRadius: "2px",
          padding: "16px",
          fontWeight: "bold",
          maxWidth: 500,
        },
        success: {
          style: {
            background: theme.surfaceSecondary,
            color: theme.text,
          },
        },
        error: {
          style: {
            background: theme.surfaceSecondary,
            color: theme.text,
          },
        },
      }}
    />
  );
};

export default ToasterDefault;
